const Tabs = Object.freeze({
  PENDING: 0,
  FINISHED: 1,
});

const SignTypes = Object.freeze({
  PART: 0,
  DELIVERY_NOTE: 1,
  DELIVERY_NOTE_NO_SIGN: 2,
});

const NewManualArticleOptions = Object.freeze({
  MANUAL_CODE: 0,
  MISC_ARTICLE: 1,
  SCAN_CODE: 2,
});

const SelectionActions = Object.freeze({
  TICK: 1,
  START_ROUTE: 1,
  START_PART: 2,
  PAUSE: 3,
  RESUME: 4,
});

const ProductionLocations = Object.freeze({
  PRODUCTION_LINE: 1, // LineaProduccion
  ADDRESS: 2, // Direccion
});

export {
  NewManualArticleOptions,
  ProductionLocations,
  SelectionActions,
  SignTypes,
  Tabs,
};
